import { Link } from "react-router-dom";
import Modal from "react-modal";
import "../styles/Containers.css";
import { ReactComponent as AroundTW } from "../media/around_the_world.svg";

export default function NoSubModal({ showModal, handleCloseModal }) {
  return (
    <Modal
      isOpen={showModal}
      onRequestClose={handleCloseModal}
      className="modal"
      overlayClassName="overlay"
    >
      <div className="modal-header">
        <h2>اشتراک نداری؟</h2>
        <Link to="" onClick={handleCloseModal}>
          <span className="icon-iconclose rectangle-1 heading-1 grey-3"></span>
        </Link>
      </div>
      <div className="modal-body">
        <div className="marginBottom5">
          <AroundTW alt="AroundTW"></AroundTW>
          <p className="rightAlign marginTop1 yekan subject-2">
            برای استفاده از پیشنهادات غذایی بیشتر و تقویم لازمه اشتراک حرفه‌ای
            داشته باشی.
          </p>
        </div>
      </div>
      <div className="modal-footer">
        <Link
          to={"/subscription"}
          className="marginBottom0-4r fill-container radius1-5"
        >
          زیر 2 دقیقه فعالش کن
        </Link>
      </div>
    </Modal>
  );
}
